var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "48", height: "48", viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M32.96,5.04 C39.5,8.14 44.18,14.48 44.9,22 L47.9,22 C46.88,9.68 36.58,0 24,0 L22.68,0.06 L30.3,7.68 L32.96,5.04 Z M20.46,3.5 C19.28,2.32 17.38,2.32 16.22,3.5 L3.5,16.22 C2.32,17.4 2.32,19.3 3.5,20.46 L27.54,44.5 C28.72,45.68 30.62,45.68 31.78,44.5 L44.5,31.78 C45.68,30.6 45.68,28.7 44.5,27.54 L20.46,3.5 Z M29.66,42.38 L5.62,18.34 L18.34,5.62 L42.38,29.66 L29.66,42.38 Z M15.04,42.96 C8.5,39.88 3.82,33.52 3.1,26 L0.1,26 C1.12,38.32 11.42,48 24,48 L25.32,47.94 L17.7,40.32 L15.04,42.96 Z", fill: "#FFFFFF", fillRule: "nonzero" })
  );
});